<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi">
<a id="page05">
<div class="epigraph">
<p class="epigraphText">And we know that all things work together for good to them that love God, to them who are the called according to his purpose.</p>
<p class="epigraphSource">—<em class="italic">Romans</em> 8:28</p>
</div>
</a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// substitutebridethe_epi.vue?776169aa